import request from "react-rb/request"

/**
 * Lists forms for the account.
 *
 * @return {object[]} The forms
 */
export async function listForms() {
  const response = await request("/forms.json", {
    method: "GET"
  })
  if (!response.ok) throw response
  return response.data?.props?.forms
}

/**
 * Create a form selection
 *
 * @param {object} params - The parameters for creating a form selection
 * @param {object} params.template - The template data
 * @param {boolean} params.iframe - Whether the request is coming from an iframe
 * @return {Promise<object>} The response data
 */
export async function createFormSelection({ template, iframe }) {
  const response = await request("/forms/designers", {
    method: "POST",
    data: { container: { template }, iframe },
    autoRedirect: false
  })
  if (!response.ok) throw response
  return response.data
}
